<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>

    export default {
        name: "costaccounting",
    }
</script>

<style lang="scss" scoped>

</style>